import React from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  getProductOperatorTotal,
  portExpanded,
  getPortExpandedProductAwards,
  getCostAnalysis,
  getFilteredPortOperatorTotal,
} from "@/onboarding/features/cost_analysis/selectors"
import { expandPort, minimizePort } from "@/onboarding/features/cost_analysis/Slice"
import { formatMoney } from "@/helpers/money"
import routes from "@/routes"

const PortOperatorTotal = ({ filteredPortProducts, operatorId }): JSX.Element => {
  const { amount, netCurrencyCode: currency } = useSelector(
    getFilteredPortOperatorTotal(filteredPortProducts)(operatorId)
  )

  // TODO Return green or red text based on minimum/maximum in the row
  return <>{formatMoney(amount, currency)}</>
}

const ProductOperatorTotal = ({ productId, operatorId }): JSX.Element => {
  const { expectedTotal, netCurrencyCode: currency } = useSelector(
    getProductOperatorTotal(productId)(operatorId)
  )

  // TODO Return green or red text based on minimum/maximum in the row
  return <>{formatMoney(expectedTotal, currency)}</>
}

const PortRow = ({ port, operators }): JSX.Element => {
  const dispatch = useDispatch()
  const selected = useSelector(portExpanded(port.id))
  const productAwards = useSelector(getPortExpandedProductAwards(port.id))
  const { selectedCruiseBrandId, selectedOperatorId } = useSelector(getCostAnalysis)

  const filteredPortProducts = port.products.filter((product) => {
    const matchesCruiseBrand =
      !selectedCruiseBrandId ||
      product.cruiseBrands.some((brand) => brand.id === selectedCruiseBrandId)

    const matchesOperator =
      !selectedOperatorId ||
      product.biddingOperators.some((operator) => operator.id === selectedOperatorId)

    return matchesCruiseBrand && matchesOperator
  })

  const operatorColumnClass = (productId, operatorId) =>
    productAwards[productId] === operatorId ? "text-right bg-secondary" : "text-right"

  const onClick = selected
    ? () => dispatch(minimizePort())
    : () => dispatch(expandPort({ portId: port.id }))

  let row

  if (filteredPortProducts.length > 0) {
    row = (
      <tr className="cursor-pointer" onClick={onClick}>
        <th scope="row">
          {`${port.name} `}
          <span className="badge bg-primary">{filteredPortProducts.length}</span>
        </th>
        <td />
        {operators.map((operator) => (
          <td key={operator.id} className="text-right">
            <PortOperatorTotal
              filteredPortProducts={filteredPortProducts}
              operatorId={operator.id}
            />
          </td>
        ))}
      </tr>
    )
  } else {
    row = (
      <tr>
        <th scope="row">{port.name}</th>
        <td />
        {operators.map((operator) => (
          <td key={operator.id} className="text-right">
            <PortOperatorTotal
              filteredPortProducts={filteredPortProducts}
              operatorId={operator.id}
            />
          </td>
        ))}
      </tr>
    )
  }

  if (selected) {
    return (
      <>
        {row}
        {filteredPortProducts.map((product) => (
          <tr key={product.id}>
            <th
              scope="row"
              className="text-underline cursor-pointer"
              onClick={() =>
                (window.location = routes.onboarding_product_cost_analysis_path({ id: product.id }))
              }
            >
              <div className="ms-3">{product.code}</div>
            </th>
            <td>{product.name}</td>
            {operators.map((operator) => (
              <td key={operator.id} className={operatorColumnClass(product.id, operator.id)}>
                <ProductOperatorTotal productId={product.id} operatorId={operator.id} />
              </td>
            ))}
          </tr>
        ))}
      </>
    )
  }

  return row
}

export default PortRow
